const moment = require('moment');
require('moment/locale/es');

const LOCATED_DATE_FORMAT = 'D MMM YYYY HH:mm:ss';
const UTC_DATE_WITHOUT_OFFSET_REGEX =
    /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;
const DATE_WITH_OFFSET_REGEX = /(z|[+-]\d{2}:?\d{2})$/i;

function isLocatedDateString(str) {
    if (typeof str !== 'string') return false;
    return /^\d{1,2}\s+(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)\.?\s+\d{4}\s+\d{1,2}:\d{2}(:\d{2})?$/i.test(
        str.trim()
    );
}

export function parseLocatedDate(dateStr) {
    if (!dateStr || !isLocatedDateString(dateStr)) return null;
    const parsed = moment(dateStr, LOCATED_DATE_FORMAT, 'es');
    return parsed.isValid() ? parsed : null;
}

function getCommentsMomentDate(date) {
    const located = parseLocatedDate(date);
    if (located) return located;

    if (
        typeof date === 'string' &&
        UTC_DATE_WITHOUT_OFFSET_REGEX.test(date.trim())
    ) {
        return moment.utc(date).local();
    }

    return moment(date);
}

function getCommentsLocale() {
    if (typeof navigator !== 'undefined' && navigator.language) {
        return navigator.language;
    }

    return 'es-AR';
}

export function formatDate(date, format = 'DD/MM/YYYY') {
    const located = parseLocatedDate(date);
    if (located) return located.format(format);
    return moment(date).format(format);
}

export function getMonthName(date) {
    return moment(date).subtract(0, 'month').startOf('month').format('MMMM');
}

export function getDayName(date) {
    return moment(date).format('dddd').substring(0, 8);
}

export function getDefaultDate(date) {
    const houres = new Date(date).getHours();
    const minutes = new Date(date).getMinutes();
    return `${houres}:${minutes < 10 ? '0' + minutes : minutes}`;
}

export function getDateNumber(date) {
    return moment(date).date();
}

export function getFullTimeFormat(date) {
    return moment(date).format('H:MM');
}

export function getDateFullYear(date) {
    return new Date(date).getFullYear();
}

export function getLocalUTC() {
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = offsetMinutes / 60;

    const offsetFormatted =
        offsetHours > 0
            ? `-${Math.abs(offsetHours)}`
            : `+${Math.abs(offsetHours)}`;

    return offsetFormatted;
}

export function formatDateTime(date) {
    const formattedTime = new Date(date).toLocaleString('es-AR', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });

    return formattedTime
        ?.replaceAll('.', '')
        ?.split(' ')
        ?.map((timeStringDivision, i) =>
            i === 1
                ? timeStringDivision.replaceAll(/\s/g, '')?.toUpperCase()
                : timeStringDivision
        )
        ?.join(' ');
}

export function formatCommentDate(date, format = 'DD/MM/YYYY') {
    return getCommentsMomentDate(date).format(format);
}

export function formatCommentDateTime(date) {
    const formattedTime = getCommentsMomentDate(date)
        .toDate()
        .toLocaleString(getCommentsLocale(), {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });

    return formattedTime
        ?.replaceAll('.', '')
        ?.split(' ')
        ?.map((timeStringDivision, i) =>
            i === 1
                ? timeStringDivision.replaceAll(/\s/g, '')?.toUpperCase()
                : timeStringDivision
        )
        ?.join(' ');
}

export function parseDateForLegacyCutoff(date) {
    if (!date) return null;

    if (moment.isMoment(date)) {
        return date.clone();
    }

    if (date instanceof Date) {
        const asMoment = moment(date);
        return asMoment.isValid() ? asMoment : null;
    }

    if (typeof date !== 'string') return null;

    const trimmedDate = date.trim();
    if (!trimmedDate) return null;

    const located = parseLocatedDate(trimmedDate);
    if (located) return located;

    const normalizedDate = trimmedDate.includes(' ')
        ? trimmedDate.replace(' ', 'T')
        : trimmedDate;
    const parsed = DATE_WITH_OFFSET_REGEX.test(normalizedDate)
        ? moment.parseZone(normalizedDate)
        : moment.utc(normalizedDate);

    return parsed.isValid() ? parsed : null;
}

export function getCommentSortMs(date) {
    const parsedDate = parseDateForLegacyCutoff(date);
    if (parsedDate && parsedDate.isValid()) return parsedDate.valueOf();
    return Number.MAX_SAFE_INTEGER;
}
